import { curl } from 'zh-common-modules';
import {
  SALE_AGENT_LIST_GET,
  AGENT_LIST_GET,
  AGENT_DETAIL_GET,
  AGENT_SCORE_GET,
  AGENT_SUB_ACCOUNT_LIST_GET,
  AGENT_LEVEL_LIST_GET,
  AGENT_DISTRIBUTION_GET,
} from "../../fetch/url";
import { get } from '../../fetch/fetch';
import { actionTypes } from "./constants";
  
export const setAgentList = data => ({
  type: actionTypes.SET_AGENTLIST,
  data
});

export const setAgentListStrId = data => ({
  type: actionTypes.SET_AGENTLIST_STR_ID,
  data
});

export const setSaleAgentList = data => ({
  type: actionTypes.SET_SALEAGENTLIST,
  data
});

export const setAgentDetail = data => ({
  type: actionTypes.SET_AGENT_DETAIL,
  data
});

export const setAgentScore = data => ({
  type: actionTypes.SET_AGENT_SCORE,
  data
});

export const setAgentSubAccountList = data => ({
  type: actionTypes.SET_AGENT_SUB_ACCOUNT_LIST,
  data
});

export const setAgentTypeList = data => ({
  type: actionTypes.SET_AGENT_TYPE_LIST,
  data
});

export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});

export const getSaleAgentList = (params) => {
  return dispatch => {
    get(SALE_AGENT_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setSaleAgentList({
            list: data.rows,
            total: data.total,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商列表失败！',
        }));
      });
  };
};

export const getAgentList = (params, cb) => {
  return dispatch => {
    get(AGENT_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          cb?.(data);
          const { rows = [] } = data;
          const rowsStrId = rows.map(_row => ({ ..._row, id: _row.id + "" }));
          dispatch(setAgentList({
            list: data.rows,
            total: data.total,
          }));

          dispatch(setAgentListStrId({
            list: rowsStrId,
            total: data.total,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商列表失败！',
        }));
      });
  };
};

export const getAgentDetail = (params) => {
  return dispatch => {
    get(AGENT_DETAIL_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setAgentDetail(data));
        }
      })
      .catch((err) => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商详情失败！',
        }));
      });
  };
};

export const getAgentScore = (params) => {
  return dispatch => {
    get(AGENT_SCORE_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setAgentScore(data));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商评分失败！',
        }));
      });
  };
};

export const getAgentSubAccountList = (params, cb) => {
  return dispatch => {
    get(AGENT_SUB_ACCOUNT_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setAgentSubAccountList({
            list: data.rows,
            total: data.count,
          }));
          cb?.(data);
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商子账号列表失败！',
        }));
      });
  };
};

export const getAgentTypeList = (params) => {
  return dispatch => {
    get(AGENT_LEVEL_LIST_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          dispatch(setAgentTypeList({
            list: data.rows,
            total: data.count,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取代理商类型列表失败！',
        }));
      });
  };
};

export const getAgentDistributionList = (params, cb) => {
  return dispatch => {
    curl
      .get(AGENT_DISTRIBUTION_GET, params)
      .then((content) => {
        cb?.(content);
      });
  };
};